<template>
    <transition-group tag="div">
        <slot></slot>
    </transition-group>
</template>

<script>
export default {
  name: "Animlist"
};
</script>




// WEBPACK FOOTER //
// src/components/Animlist.vue